import { AppAccountSettingRepository } from "@/domain/repository/app-account-setting-repository";

export class RemoveAuthorizedTokenUsecase {
  constructor(private readonly repo: AppAccountSettingRepository) {}

  execute() {
    return this.repo.removeAuthorizedToken();
  }
}
